var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsAiCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3949 6.66869C33.0634 3.3371 28.632 1.50635 23.9225 1.50635C19.2065 1.50635 14.7817 3.3371 11.4501 6.66869C8.11848 10.0003 6.28125 14.4316 6.28125 19.1411C6.28125 28.6701 15.2927 36.6013 20.1381 40.8579C20.8109 41.4531 21.3866 41.9641 21.8524 42.3911C22.4346 42.9345 23.1786 43.2062 23.9225 43.2062C24.6664 43.2062 25.4104 42.9345 25.9861 42.3911C26.4519 41.9641 27.0341 41.4531 27.7069 40.8579C32.5458 36.6013 41.5573 28.6701 41.5573 19.1411C41.5573 14.4316 39.7265 10.0003 36.3949 6.66869Z",
    fill: "#38BCDB",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 17.6856L21.5947 11.1185C21.2315 10.951 20.8004 11.1072 20.6312 11.4683L17.6997 17.7442C17.6183 17.9181 17.6098 18.1174 17.6756 18.2976C17.7415 18.4778 17.8759 18.6249 18.0501 18.7062L20.2171 19.7151L19.4659 21.3236C19.3846 21.4974 19.376 21.6967 19.4419 21.8769C19.5078 22.0572 19.6422 22.2042 19.8164 22.2855L21.139 22.9013L19.415 26.5929H17.2721V25.0231C17.2721 24.6229 16.9479 24.2992 16.5472 24.2992C16.1465 24.2992 15.8223 24.6229 15.8223 25.0231V29.6089C15.8223 30.0089 16.1465 30.3327 16.5472 30.3327C16.9479 30.3327 17.2721 30.0089 17.2721 29.6089V28.0404H19.8765C20.1583 28.0404 20.4146 27.8771 20.5335 27.6227L22.453 23.5129L23.7715 24.1268C23.8706 24.1728 23.9748 24.1947 24.0773 24.1947C24.3506 24.1947 24.6119 24.0398 24.735 23.7769L25.4862 22.1684L29.7245 24.1416C29.8235 24.1876 29.9276 24.2095 30.0302 24.2095C30.3035 24.2095 30.5647 24.0547 30.6879 23.7918L30.8003 23.5511L32.5746 24.377C32.6736 24.4229 32.7777 24.4448 32.8803 24.4448C33.1536 24.4448 33.4148 24.2901 33.538 24.0271L35.213 20.4407C35.3821 20.0781 35.2251 19.6477 34.8626 19.4787L34.5972 19.3551L35.6143 19.0306C35.8983 18.9402 36.0979 18.685 36.117 18.3874C36.1362 18.0899 35.9704 17.8113 35.7 17.6856ZM33.4071 18.2156L31.9651 18.6758L21.2046 13.6658L21.6386 12.7363L33.4071 18.2156ZM31.4135 22.2395L32.3125 20.3132C32.3555 20.2255 32.429 19.9893 32.5619 20.0045L33.5925 20.4845L32.5306 22.7591L31.4135 22.2395Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4501",
    x: 0.78125,
    y: 0.00634766,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4501"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4501",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsAiCamera);
export default __webpack_public_path__ + "static/media/eventsAICamera.8e5a62bb77d40c1c153c9a08daf9394d.svg";
export { ForwardRef as ReactComponent };